import { useEffect, useState, useMemo } from 'react';
import { ColumnVisibilityModels } from '../../Components/Table/ColumnVisibilityModels';
import { UseColumnVisibilityProps } from '../../types';

export function useColumnVisibility({
  isMapping,
  mappingContent,
  restrictChemical,
  view,
  tab,
  isEvidence,
}: UseColumnVisibilityProps) {
  const selectColumnVisibilityModel = useMemo(() => {
    const fnColumnVisibilityModel =
      isMapping && mappingContent?.isActive
        ? () => ColumnVisibilityModels.getByMappingName(mappingContent.columVisibilityModelKey, isEvidence)
        : () => ColumnVisibilityModels.getByViewTab(view, tab, isEvidence);

    const fnColumnVisibilityModelWithRestrictions = () => {
      const originalList = fnColumnVisibilityModel();
      const restrictedList = restrictChemical
        ? ['gof_lof', 'chemsInSentence', 'chemID', 'chemIDs', 'chemical_effect']
        : [];
      return originalList && restrictedList
        ? Object.fromEntries(Object.entries(originalList).filter(([key]) => !restrictedList.includes(key)))
        : undefined;
    };

    return fnColumnVisibilityModelWithRestrictions;
  }, [view, tab, mappingContent?.columVisibilityModelKey, restrictChemical, isMapping, isEvidence]);

  const [columnVisibilityModel, setColumnVisibilityModel] = useState(selectColumnVisibilityModel());

  useEffect(() => {
    setColumnVisibilityModel(selectColumnVisibilityModel());
  }, [selectColumnVisibilityModel]);

  return { columnVisibilityModel, setColumnVisibilityModel };
}
